import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-search-eye-line',
    title: '風險評估規劃',
    desc: '透過全面的風險分析，找出您人生各階段的保障缺口，量身打造最適合的保險組合，讓每一分保費都花在刀口上。',
    color: 'bg-[#0F2847]',
    textColor: 'text-white',
    descColor: 'text-white/75',
    linkColor: 'text-[#C9A84C]',
  },
  {
    icon: 'ri-file-search-line',
    title: '保單健檢優化',
    desc: '針對現有保單進行全面健檢，找出重複投保、保障不足或費率偏高的問題，協助您優化保障結構，節省不必要的支出。',
    color: 'bg-white',
    textColor: 'text-[#0F2847]',
    descColor: 'text-gray-600',
    linkColor: 'text-[#C9A84C]',
    border: true,
  },
  {
    icon: 'ri-draft-line',
    title: '客製化方案設計',
    desc: '根據您的家庭結構、財務狀況與人生目標，設計專屬的保障藍圖。從壽險、醫療到退休規劃，一站式完整服務。',
    color: 'bg-[#FDF6E3]',
    textColor: 'text-[#0F2847]',
    descColor: 'text-gray-600',
    linkColor: 'text-[#C9A84C]',
  },
];

const extraServices = [
  { icon: 'ri-customer-service-2-line', title: '理賠協助', desc: '全程陪同理賠，讓您在最需要的時候不孤單' },
  { icon: 'ri-chat-3-line', title: '保險諮詢', desc: '隨時解答您的保險疑問，提供專業建議' },
  { icon: 'ri-refresh-line', title: '定期追蹤', desc: '每年定期回訪，確保保障與您的人生同步更新' },
];

export default function ServicesHighlight() {
  return (
    <section className="bg-[#F8F9FA] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A84C] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            OUR SERVICES
          </p>
          <h2
            className="font-serif font-bold text-[#0F2847] mb-4"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            專業服務項目
          </h2>
          <div className="w-16 h-1 bg-[#C9A84C] mx-auto rounded-full"></div>
          <p className="text-gray-600 mt-6 max-w-xl mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            以建築師的嚴謹態度，為您的保障打下穩固基礎
          </p>
        </div>

        {/* Main Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {services.map((svc) => (
            <div
              key={svc.title}
              className={`${svc.color} ${svc.border ? 'border border-gray-200' : ''} rounded-2xl p-8 flex flex-col hover:-translate-y-1 transition-transform duration-300`}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#C9A84C]/15 mb-6">
                <i className={`${svc.icon} text-[#C9A84C] text-3xl`}></i>
              </div>
              <h3
                className={`font-serif font-bold ${svc.textColor} mb-4`}
                style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.5' }}
              >
                {svc.title}
              </h3>
              <p className={`${svc.descColor} flex-1`} style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
                {svc.desc}
              </p>
              <Link
                to="/services"
                className={`inline-flex items-center gap-1 mt-6 font-semibold ${svc.linkColor} hover:gap-2 transition-all duration-200`}
                style={{ fontSize: '1.0625rem' }}
              >
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>

        {/* Extra Services */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {extraServices.map((svc) => (
            <div
              key={svc.title}
              className="bg-white border border-gray-100 rounded-xl p-6 flex items-center gap-5 hover:border-[#C9A84C]/40 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#0F2847]/8 flex-shrink-0">
                <i className={`${svc.icon} text-[#0F2847] text-xl`}></i>
              </div>
              <div>
                <h4 className="font-semibold text-[#0F2847] mb-1" style={{ fontSize: '1.1875rem' }}>{svc.title}</h4>
                <p className="text-gray-500" style={{ fontSize: '1rem', lineHeight: '1.6' }}>{svc.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 border-2 border-[#0F2847] text-[#0F2847] px-8 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#0F2847] hover:text-white transition-all duration-200"
            style={{ fontSize: '1.1875rem' }}
          >
            查看完整服務項目
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
